import constants from 'crm/common/constants'

const {defaultChannelTitle} = constants
/**
 * 客户渠道分布
 * @param data
 * @returns {[]|Array}
 */
export function parseCustomerChannels(data) {
    if (Array.isArray(data)) {
        const channels = []
        data.forEach((item) => {
            // 默认渠道（无渠道）
            if (item.state === '') {
                item = {
                    ...item,
                    channel: {
                        name: defaultChannelTitle,
                    },
                }
            }
            channels.push(item)
        })
        return channels
    }
    return []
}
